import {
	AerInputStructure,
	type InputProps,
} from "@aerstudios/aerated-aerinputstructure";
import type { WidgetProps } from "@rjsf/utils";
import cx from "clsx";
import React, { useState } from "react";
import { useFormBuilderContext } from "../FormBuilder/FormBuilder.context";
import * as styles from "./TextArea.module.scss";

type Props = WidgetProps<InputProps>;

export const TextArea: React.FC<Props> = ({
	onFocus,
	onBlur,
	onChange,
	className,
	readonly,
	value,
	...aerTextAreaProps
}) => {
	const [inputValue, setInputValue] = useState(value);
	const {
		uiSchema: _uiSchema,
		formContext: _formContext,
		rawErrors: _rawErrors,
		hideLabel: _hideLabel,
		hideError: _hideError,
		autofocus: autoFocus,
		...aerTextAreaPropsRest
	} = aerTextAreaProps;
	const { hasSubmitted } = useFormBuilderContext();
	return (
		<AerInputStructure.Root
			handleChange={(newValue: string) => {
				setInputValue(newValue);
				onChange(newValue);
			}}
			onFocus={(v) => onFocus(aerTextAreaProps.id, v)} // TODO TBC: Mismatch between WidgetProps and AerTextInputProps
			handleBlur={(v) => onBlur(aerTextAreaProps.id, v)} // TODO TBC: Mismatch between WidgetProps and AerTextInputProps
			autoFocus={autoFocus}
			value={inputValue}
			errorMessage={aerTextAreaProps.rawErrors?.[0]}
			forceValidityCheck={hasSubmitted}
			{...aerTextAreaPropsRest}
		>
			<AerInputStructure.Input
				readOnly={readonly}
				className={cx(styles.textArea, className)}
				disabled={aerTextAreaProps.schema?.readOnly}
			>
				<textarea />
			</AerInputStructure.Input>
			<AerInputStructure.ErrorMessage />
			<AerInputStructure.CharacterCount
				maxCount={aerTextAreaPropsRest.schema.maxLength}
			/>
		</AerInputStructure.Root>
	);
};
export default TextArea;
